module.exports = __webpack_public_path__ + "img/chrome.a5d1d4e8.svg";